import React, { Fragment, useState } from 'react';
import { AsyncSelect } from "../../../common/components/Select/Select";
import {adminSearchDesigners, getAdminCalendarDesigners} from "../api/AdminCalendarApi";

const AddDesignerPopup = ({ calendar, designers: initialDesigners, onCloseModal }) => {
  const [designers, setDesigners] = useState(initialDesigners);
  const [selectedDesigner, setSelectedDesigner] = useState(null);

  const shortDomain = email => email.replace(/(@)[^)]*/g, "$1mbr");

  const prepareUserValues = designersArray =>
    designersArray.reduce((acct, d) => {
      acct.push({ ...d, value: d.id, label: `${d.full_name} <${shortDomain(d.email)}>` });
      return acct;
    }, []);

  const handleLoadOptions = (search, callback) => {
    adminSearchDesigners(
      calendar,
      search,
      data => {
        // setDesigners(data.designers);
        callback(prepareUserValues(data.designers));
      },
      error => {
        console.log(error);
      },
    );
    return null;
  };

  // Dummy function to add a designer to the server
  const addDesignerToServer = (designer) => {
    console.log("Adding designer to server:", designer);
    // Simulate server interaction
    return Promise.resolve();
  };

  // Dummy function to remove a designer from the server
  const removeDesignerFromServer = (designerId) => {
    console.log("Removing designer from server:", designerId);
    // Simulate server interaction
    return Promise.resolve();
  };

  const onDesignerOptionChange = (option) => {
    setSelectedDesigner(option);
  };

  const handleAddDesigner = () => {
    if (selectedDesigner) {
      addDesignerToServer(selectedDesigner);
      setDesigners([...designers, selectedDesigner]);
      setSelectedDesigner(null);
    }
  };

  const handleRemoveDesigner = (designerId) => {
    removeDesignerFromServer(designerId);
    setDesigners(designers.filter((designer) => designer.id !== designerId));
  };

  const styles = {}; // Add custom styles if necessary

  return (
    <Fragment>
      <div className="popupBackShadow" onClick={onCloseModal} />
      <div className="simplePopup addRemoveDeignerPopup">
        <div className="moodboard-modal_close" onClick={onCloseModal} />
        <h2>Add/Remove Designers</h2>

        <div className="popupInputsOneLine">
          <AsyncSelect
            loadOptions={handleLoadOptions}
            value={selectedDesigner}
            onChange={onDesignerOptionChange}
            styles={styles}
            placeholder="Search for a designer"
            className='popupInput'
          />
          <button onClick={handleAddDesigner} className="btn -empty -y2023">
            Add Designer
          </button>
        </div>

        <div className="designer-list">
          {designers.map((designer) => (
            <div key={designer.id} className="designer-item">
              <span>{`${designer.full_name} (${shortDomain(designer.email)})`}</span>
              <button
                onClick={() => handleRemoveDesigner(designer.id)}
                className="btn -empty -sm -red -remove removeDesignerButton"
              >
                Remove
              </button>
            </div>
          ))}
        </div>

        <div className={'popupActions'}>
          <button onClick={onCloseModal} className="btn -empty -y2023">
            Ok
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default AddDesignerPopup;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/AddDesignerPopup.js